var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpButton", {
    attrs: {
      spinning: _vm.actions.submit.isRunning,
      variant: "primary",
      size: _vm.size,
      text: _vm.messages.bntText,
      tooltip: _vm.messages.btnTooltip
    },
    on: {
      click: function($event) {
        $event.preventDefault()
        $event.stopPropagation()
        return _vm.evh_7315092382398562_clickPreventStop($event, {})
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }